export default __webpack_public_path__ + "static/media/santamaria.82005087.png";